import './Services.scss';

import { $ } from "../../../common/scripts/Libs";

class Services {

  constructor(node) {
    this.node = node;
  }

  init() {
    var speed = 250;

    $(this.node).find('.Services__tabs--list ul li:first-child a').addClass('active');
    $(this.node).find('.Services__tabs--content').hide();
    $(this.node).find('.Services__tabs--content:first').show();

    $(this.node).find('.Services__tabs--list ul li a').click(function () {
      $('.Services__tabs--list ul li a').removeClass('active');
      $(this).addClass('active');
      $('.Services__tabs--content').fadeOut(speed);

      var activeTab = $(this).attr('href');
      setTimeout(function () {
        $(activeTab).fadeIn(speed);
      }, speed);

      return false;
    });
  }

}

JSModules['Services'] = Services;
export default Services;
